const classdetaillList = [
  {
    id: 1,
    img: 1,
    title: '采购案例解析',
    name: "吴小明",
    classnumber: '38', //节课
    time: '28', //课时
    money: '399.00', //money
    classtype: '精品课', //课程类型
    termtime: '购买后12个月', //有效时间
    number: '38', //节数
    teacher: '吴小明',
    classmore: '政府采购',
    teacherinfo: '吴小明，政府采购专家、高级经济师。曾作为中国代表团成员参加WTO政府采购协议谈判。中国政府采购研究所特聘专家，中国政府采购年鉴、中国政府采购网编委。出版个人专著《政府采购法律法规、实务操作与案例解析》、主编《政府采购基础知识》等10部专业书，发表文章数百篇。其独特的案例教学法获得广泛认可和好评。',
    content: `   <span
        >吴小明，曾作为中国代表团成员参加WTO政府采购协议谈判，在中美、中欧政府采购研讨会代表中方发言。参与政府采购相关制度的起草修改。在省级政府采购监管部门工作多年，一直致力于推进地方政府采购制度的改革与创新。</span
      >
      <span
        >在多年的政府采购监管工作中，曾八次当“被告”、十几次上法庭。尽管八次“被告”都胜诉了，但每一个案件都有太多值得反思之处。在实践中我深切体会到，在政府采购活动中，依法采购、严格程序、规范操作的重要性，希望能与大家一起分享处理过程和心得，为依法妥善处理供应商质疑投诉提供一些启示和借鉴。</span
      >
      <span
        >本课程的特点是突出实用性。内容涵盖了政府采购工作中涉及的各项法律法规、具体操作实务以及各类典型案例解析。</span
      >
      <span
        >在法律法规部分，采用条目形式，对各个环节适用的法律法规及办法，包括《政府采购法》《政府采购法实施条例》、财政部部长令以及近几年新出台的制度办法，按级次梳理，编制目录，解析要点，明确规则，方便查找运用。</span
      >
      <span>
        这一部分的内容主要包括:概述；采购准备；选择采购方式；信息公告；招标、投标；开标、评标；中标和合同；询问、质疑、投诉，行政复议与行政诉讼；监督检查、法律责任以及国有金融企业集中采购管理等等。</span
      >
      <span
        >在实务操作部分，结合政府采购实务操作的流程和要点，对实务操作中的一些重点难点问题作了深入浅出的总结和阐述，并附录了一些具体范文及做法，理论联系实际。</span
      >
      <span
        >这一部分的内容主要针对政府采购实务操作中的重点环节，如采购需求确定、采购方式选择、招标采购程序及注意事项、非招标采购程序及注意事项、履约验收管理、合同签订、质疑与投诉处理、内控制度建设等，将实践中行之有效的做法整理归纳，提供实务操作办法。</span
      >
      <span
        >在案例分析部分，通过对近年来发生的，涵盖政府采购各环节的38个典型案例进行解析，以案说法。包括要点提示、案情概述、点评分析、处理方法、法规链接等，希望能提供一些启示和借鉴。</span
      >
      <span
        >这一部分的主要内容，是对发生在招标、投标、评标、中标等环节的典型案例，供应商违法违规案例，质疑投诉处理案例等进行解析，并对采购需求确定、采购合同签订、履约验收、诚信管理、内控制度建设等内容进行重点讲解。</span
      >
      <span
        >这些案例中，既有招标环节操作机构和采购人的情理与法律的碰撞、招标文件中一些重要概念的分歧乃至若隐若现的倾向性，又有投标环节供应商投标文件内容的明显疏漏、评标环节评审专家的一句题外话或者善意迁就、供应商在落标后的无理取闹等等。同时，如何判断采购人提出的采购需求是否合法？如何认定技术指标是否具有倾向性、排他性？如何解释招标文件中重要概念的歧义？投标人报价错误应如何进行修正？认定投标文件中的重大负偏离应如何把握？评标委员会的评审范围和权限如何界定？对违规供应商的处罚需要考虑哪些情形等等，这些困扰从业人员的操作性问题，都将通过对案例的解析，一一予以剖析和解答。通过对来源于工作实践中鲜活实用的经验，进一步启发思维、回应困惑，依法妥善处理。由于多数案例都是我亲身经历、亲自处理的，案例的评析更侧重于工作体会的记录和工作经验的总结，有些案例则坦诚而无掩饰地说明我在事后进一步思考总结出来的不足和教训，因此，所提出的操作方法是具体实在的，融合了对法律精神的理解和工作技巧的运用。</span
      >
      <span
        >时任财政部政府采购办公室主任王瑛在为我的个人专著作序时曾评价：“作者确实是一位专业知识厚实、颇有见地的专家型管理者。她对政府采购法律、政策有着准确把握和广泛实践。书中涵盖的政府采购各项内容均有不落窠臼的表达，形式鲜活、内容实用，希望能成为采购人必读的专业教材或必备的‘活字典’”。</span
      >
      <span
        >希望通过本课程的学习，能帮助大家加深对政府采购法律法规的理解，提高政府采购实务操作的水平，提升处理质疑投诉工作的能力，进一步做好政府采购工作。</span
      >`,
    catalogue: ` <ul>
        <li>1.关于评标专家评审问题</li>
        <li>2.关于采购代理机构权利问题</li>
        <li>3.关于保证金退还问题</li>
        <li>4.关于政府采购项目实施主体问题</li>
        <li>5.关于供应商低于成本问题</li>
        <li>6.关于开标资料保存问题</li>
        <li>7.关于支付代理服务费问题</li>
        <li>8.关于变更评审专家问题</li>
      </ul>`,
    light: '在这门课程里，内容涵盖了政府采购工作过程中涉及的各项法律法规、具体的每一步操作实务以及各类典型的案例分析：法律法规部分采用条目的形式，按照政府采购操作流程，对各个环节适用的法律法规及办法按级次梳理，解析要点，方便读者查找运用；实务操作部分，对实务操作中的重点环节整理归纳，具体环节提供模板，读者可以直接复制使用；案例分析部分，对近年发生的政府采购典型案例进行解析，包括要点提示、案情概述、点评分析、法规链接等，为实践提供启示和借鉴。',
    video: 'https://img2.cyc-fund.com.cn/hongyunmp4/%E9%87%87%E8%B4%AD%E6%A1%88%E4%BE%8B%E8%A7%A3%E6%9E%90.mp4',
  },
  {
    id: 2,
    img: 2,
    title: '国有企业招标采购专业实务及案例分析',
    name: "袁静",
    classnumber: '9', //节课
    time: '20', //课时
    money: '499.00', //money
    classtype: '精品课', //课程类型
    termtime: '购买后12个月', //有效时间
    number: '15', //节数
    teacher: '袁静',
    classmore: '国有企业招标',
    teacherinfo: '参与国家发改委、交通运输部、湖北省交通运输厅、湖南省交通运输厅、云南省交通运输厅等多个部门政策研究课题、标准招标文件编制，具有丰富的工程咨询及招标工作经验。',
    content: `   <span
    >国企采购实操中存着泛招标化的问题，如何选择合适的采购方式？国有企业招标采购全流程国有企业招标采购全流程操作常见难点和风险防范有哪些？如何合法合规的开展招标采购活动？本课程从国有企业必须招标的项目范围确定开始讲解，结合案例分析国有企业招标采购全流程操作实务难点和风险防范，并对招标采购合规管理与监督审计热点难点解析进行了讲解。通过课程的学习有助于从业人员解决全流程操作的难点问题，进一步在实际工作中学以致用。本课程主要包含以下内容：</span
  >
  <span
    >1. 招标采购法律法规与政策体系的构成</span
  >
  <span
    >2. 强制招标制度</span
  >
  <span
    >3. 依法必招项目案例分析</span
  >
  <span>
    4. 依法必招项目判定思考</span
  >
  <span
    >5. 工程项目招投标领域营商环境专项整治工作方案</span
  >
  <span
    >6. 企业招标采购制度建设</span
  >
  <span
    >7. 国有企业采购内控制度建设</span
  >
  <span
    >8. 某企业集团招标采购管理制度案例</span
  >
  <span
    >9. 框架协议采购简介</span
  >
  <span
    >10. 某集团二级公司招标代理机构库比选案例</span
  >
  <span
    >11. 招标文件编制过程中存在的主要问题及风险防范</span
  >
  <span
    >12. 资格条件设置的注意事项</span
  >
  <span
    >13. 同一品牌投标（货物）的处理方法</span
  >
  <span
    >14. 投标人不得存在的情形</span
  >
  <span
    >15. 使用标准招标文件</span
  >
  <span
    >16. 明确实质性要求和否决投标的情形</span
  >
  <span
    >17. 不得出现违法、歧视性条款</span
  >
  <span
    >18. 语言规范简练，内容一致</span
  >
  <span
    >19. 招标过程中存在的主要问题及风险防范</span
  ><span
    >20. 依法必须进行招标的项目与自愿招标的项目的主要区别</span
  ><span
    >21. 投标过程中存在的主要问题及风险防范</span
  ><span
    >22. 开标过程中存在的主要问题及风险防范</span
  ><span
    >23. 评标过程中存在的主要问题及风险防范</span
  ><span
    >24. 定标、签订合同过程中存在的主要问题及风险防范</span
  ><span
    >25. 招标采购工作审计重点</span
  ><span
    >26. 招标采购合规管理典型案例解析（15个案例）</span
  >`,
    catalogue: ` <ul>
    <li>1.招标采购法律法规与政策体系的构成</li>
    <li>2.强制招标制度</li>
    <li>3.依法必招项目判定思考</li>
    <li>4.工程项目招投标领域营商环境专项整治工作方案</li>
    <li>5.企业招标采购制度建设</li>
    <li>6.国有企业采购内控制度建设</li>
    <li>7.招标文件编制过程中存在的主要问题及风险防范</li>
    <li>8.招标过程中存在的主要问题及风险防范</li>
    <li>9.依法必须进行招标的项目与自愿招标的项目的主要区别</li>
  </ul>`,
    light: '本门课程内容涵盖了政府采购工作过程中涉及的各项法律法规、具体操作实务以及各类典型的案例分析。法律法规部分，采用条目的形式，按照政府采购操作流程，对各个环节适用的法律法规及办法按级次梳理，解析要点，方便查找运用；实务操作部分，将实践中行之有效的做法整理归纳，提供操作办法；案例分析部分，对近年来发生的政府采购典型案例进行解析，包括要点提示、案情概述、点评分析、法规链接等，为实践提供启示和借鉴。',
    video: 'https://img2.cyc-fund.com.cn/hongyunmp4/%E5%9B%BD%E6%9C%89%E4%BC%81%E4%B8%9A%E6%8B%9B%E6%A0%87%E9%87%87%E8%B4%AD%E4%B8%93%E4%B8%9A%E5%AE%9E%E5%8A%A1%E5%8F%8A%E6%A1%88%E4%BE%8B%E5%88%86%E6%9E%90.mp4',
  },
  {
    id: 3,
    img: 3,
    title: '施工标评审实务',
    name: "何建新",
    classnumber: '9', //节课
    time: '18', //课时
    money: '1099.00', //money
    classtype: '精品课', //课程类型
    termtime: '购买后12个月', //有效时间
    number: '10', //节数
    teacher: '何建新',
    classmore: '评标',
    teacherinfo: '北京大学化学与分子工程学院副教授、主要研究领域核磁共振的应用、有机合成、氮叶立德化学、有机技术化学。',
    content: `   <span
    >本专栏重点讲述了评标概念、依据、评标委员会、串标、弄虚作假、以他人名义投标、无效标、计算性算数错误修正、投标文件澄清和说明、评标结果、定标、评委责任、形式评审、资格评审、响应性评审、经评审最低投标价法、综合评估法等评标的基础知识以及当前水利施工标评审中需要注意的开标、分包评审、联合体评审、异议评审、偏差、备选投标方案评审、有效标不足三家处理、项目负责人答辩、多标段评标、成本价界定、招标文件错误处理等问题，结合“引江济淮试验段评标”案例介绍了水利施工评标工作。</span
  >`,
    catalogue: `  <ul>
    <li>1.评标依据</li>
    <li>2.评标委员会</li>
    <li>3.招标人与评委的关系</li>
    <li>4.无效标的认定</li>
    <li>5.计算性算术错误修正</li>
    <li>6.投标文件澄清和说明</li>
    <li>7.经评审最低投标价法</li>
    <li>8.开标中的评标问题</li>
    <li>9.分包情形评审</li>
  </ul>`,
    light: '本门课程内容涵盖了政府采购工作过程中涉及的各项法律法规、具体操作实务以及各类典型的案例分析。法律法规部分，采用条目的形式，按照政府采购操作流程，对各个环节适用的法律法规及办法按级次梳理，解析要点，方便查找运用；实务操作部分，将实践中行之有效的做法整理归纳，提供操作办法；案例分析部分，对近年来发生的政府采购典型案例进行解析，包括要点提示、案情概述、点评分析、法规链接等，为实践提供启示和借鉴。',
    video: 'https://img2.cyc-fund.com.cn/hongyunmp4/%E6%96%BD%E5%B7%A5%E6%A0%87%E8%AF%84%E5%AE%A1%E5%AE%9E%E5%8A%A1.mp4',
  },
  {
    id: 4,
    img: 4,
    title: '大数据技术对公共资源交易信息安全风险影响探析',
    name: "汤骏",
    classnumber: '5', //节课
    time: '22', //课时
    money: '899.00', //money
    classtype: '精品课', //课程类型
    termtime: '购买后12个月', //有效时间
    number: '5', //节数
    teacher: '汤骏',
    classmore: '公共资源交易',
    teacherinfo: '汤骏，南通市公共资源交易中心副主任。工学硕士，高级工程师，长期从事工程管理和招投标服务和信息化工作，在《中国标准化》、《中国管理信息化》...',
    content: `   <span
    >这是公共资源交易行业第一次采用大数据（主要是爬虫）技术在交易信息安全领域进行的实战攻击演习，揭示了当前我国公共资源交易信息化管理可能面临的最大挑战，呼吁有关部门高度重视大数据技术对于公共资源交易安全造成的巨大冲击。</span
  >`,
    catalogue: `  <ul>
    <li>1.交易平台</li>
    <li>2.公共服务平台</li>
    <li>3.电子招标投标行政监督及创新网络条件下的行政监督</li>
    <li>4.电子招标投标的标准化、信息化</li>
    <li>5.电子招标投标系统检测认证</li>
  </ul>`,
    light: ' 1、本次课程披露了不少涉密技术细节，从公共资源交易管理者的角度来看，可以就上述风险因素迅速采用有效措施予以严密防控。同时，为相关监督管理部门就进一步加强公共资源交易信息安全管理以启发。2、课程公开的一些大数据技术，将对我国现行的以主体信息公示方式组织招投标活动的传统做法产生巨大的冲击，可能对我国招投标管理方式的变革产生一定的影响。',
    video: 'https://img2.cyc-fund.com.cn/hongyunmp4/%E5%A4%A7%E6%95%B0%E6%8D%AE%E6%8A%80%E6%9C%AF%E5%AF%B9%E5%85%AC%E5%85%B1%E8%B5%84%E6%BA%90%E4%BA%A4%E6%98%93%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8%E9%A3%8E%E9%99%A9%E5%BD%B1%E5%93%8D%E6%8E%A2%E6%9E%90.mp4',
  },
  {
    id: 5,
    img: 5,
    title: '公共资源交易',
    name: "张志军",
    classnumber: '12', //节课
    time: '28', //课时
    money: '1699.00', //money
    classtype: '精品课', //课程类型
    termtime: '购买后12个月', //有效时间
    number: '12', //节数
    teacher: '张志军',
    classmore: '公共资源交易',
    teacherinfo: '曾任宁波市政务服务办公室（公共资源交易管理办公室）党组副书记、副主任，二级巡视员，分管公共资源交易管理处、市招标投标监管中心，从事公共资源市场化配置改革工作多年...',
    content: `   <span
    >多年来，各地积极推进公共资源交易平台建设，深化公共资源市场化配置改革，在完善公共资源交易管理体制和运作机制、建立健全监督管理制度、拓展公共资源交易范围等方面做了大量工作，取得了明显的经济、社会和政治效益。与此同时，公共资源交易管理工作中还存在不少问题，如体制机制不一、信用监管缺失等。</span
  >
  <span
    >对此，我将近年来在工作中碰到的一些问题，特别是在操作层面的一些问题及由此引起的一些思考与大家交流。</span
  >
  <span>主要内容包括三个方面：</span>
  <span>第一、关于公共资源交易监管体制；</span>
  <span>
    这一部分的内容主要包括:第二、关于工程建设领域诚信体系建设；</span
  >
  <span
    >在实务操作部分，结合政府采购实务操作的流程和要点，对实务操作中的一些重点难点问题作了深入浅出的总结和阐述，并附录了一些具体范文及做法，理论联系实际。</span
  >
  <span>第三、关于公共资源交易管理若干问题的思考。</span>
  <span
    >希望通过对当前公共资源交易监督管理存在问题和难点的分析，和对深化交易监督管理程序创新举措的介绍，帮助大家加深对“公共资源交易集中监管和信用监管”的理解，有助形成监管合力，提高交易监管效率，进一步做好公共资源交易监督管理工作。</span
  >`,
    catalogue: `   <ul>
    <li>一：海洋资源交易</li>
    <li>1.海域使用权出让</li>
    <li>2.无居民海岛等海洋资源使用权出让</li>
    <li>二：林权交易</li>
    <li>1.国有林地使用权、租赁权和林木所有权出让</li>
    <li>2.集体统一经营管理的林地经营权和林木所有权出让</li>
    <li>三：农村集体产权交易</li>
    <li>1.农村集体土地经营权流转</li>
    <li>2.农村集体经营性资产出租</li>
    <li>3.农村集体资产股权转让</li>
    <li>4.四荒（荒山，荒沟，荒丘，荒滩）地使用权流转</li>
    <li>四：无形资产交易</li>
    <li>1.基础设施和公共事业特许经营权授予</li>
    <li>2.市政公用设施及公共场地使用权，承包经营权</li>
    <li>五：排污权交易</li>
    <li> 1.定额出让排污权</li>
    <li>2.公开拍卖排污权</li>
  </ul>`,
    light: '本门课程内容涵盖了政府采购工作过程中涉及的各项法律法规、具体操作实务以及各类典型的案例分析。法律法规部分，采用条目的形式，按照政府采购操作流程，对各个环节适用的法律法规及办法按级次梳理，解析要点，方便查找运用；实务操作部分，将实践中行之有效的做法整理归纳，提供操作办法；案例分析部分，对近年来发生的政府采购典型案例进行解析，包括要点提示、案情概述、点评分析、法规链接等，为实践提供启示和借鉴。',
    video: 'https://img2.cyc-fund.com.cn/hongyunmp4/%E5%85%AC%E5%85%B1%E8%B5%84%E6%BA%90%E4%BA%A4%E6%98%93.mp4',
  },
]

export default classdetaillList